import { Input, Select } from 'antd';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as Papa from 'papaparse';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { inject, observer } from 'mobx-react';
import Dropzone from 'react-dropzone';
import IconSvg from '../../common/IconSvg';
import FileName from '../../common/FileName';
import { themeColors } from '../../../constants/themes';
import {
  UploadLink,
  IconsWraper,
  ImportCsvContainer,
  ImportCsvText,
  UploadSuccess,
  FlexContainer,
  DownloadSample,
  CategoryTitle,
} from './styled';
import ENUMS from '../../../constants/enums';

const { Option } = Select;

@injectIntl
@inject('onboardingStore')
@inject('discoveryStore')
@inject('toastsStore')
@inject('dashboardStore')
@inject('ordersStore')
@observer
class ReadyToLaunchAdvanced extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isContent: false,
      uploadedSuccess: false,
      singleEntryFilled: false,
      fileName: '',
    };
    this.dropzoneRef = null;
    // this.textarea;
  }

  componentDidMount(){
    const {
      onboardingStore: {
        setImportSource
      },
      discoveryStore: { availableSourceMarketPlaces,availableDestinationMarketPlaces,setListingSelected }
    } = this.props
    setImportSource(availableSourceMarketPlaces[0]);
    setListingSelected(availableDestinationMarketPlaces[0])
  }

  onDrop = acceptedFiles => {
    const {
      onboardingStore: { setImportedData },
      toastsStore: { showToast },
    } = this.props;
    const file = acceptedFiles[0];
    if (
      file &&
      file.name &&
      (file.name.split('.').pop() === 'csv' ||
        file.name.split('.').pop() === 'xls' ||
        file.name.split('.').pop() === 'xlsx')
    ) {
      Papa.parse(file, {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        complete: results => {
          const errorsObj = { ms: false, md: false }; // ms=missing source, md=missing destination
          if (results.errors.length) {
            showToast({
              type: ENUMS.TOAST_TYPES.WARNING,
              message:
                'There was an error with the format of your file. Click "See Format" to get an example',
            });
          } else if (
            results.data.some(row => {
              if (errorsObj.ms || errorsObj.md) {
                return true;
              }
              if (!row.source_id) {
                errorsObj.ms = true;
              }
              if (!row.destination_id) {
                errorsObj.md = true;
              }
              return errorsObj.ms || errorsObj.md;
            })
          ) {
            const errors = `Missing ${errorsObj.ms ? 'source id' : ''}${
              errorsObj.md && errorsObj.ms ? ' and ' : ''
            }${errorsObj.md ? 'destination id' : ''}`;
            showToast({
              type: ENUMS.TOAST_TYPES.WARNING,
              message: errors,
            });
          } else {
            setImportedData(results.data);
            this.setState({ uploadedSuccess: true, fileName: file.name });
          }
        },
      });
    } else {
      showToast({
        type: ENUMS.TOAST_TYPES.WARNING,
        message: 'Please drop only CSV file !!!',
      });
    }
  };

  onDropOrders = async acceptedFiles => {
    const {
      toastsStore: { showToast },
      ordersStore: { setImportedOrdersCSV },
    } = this.props;
    const file = acceptedFiles[0];
    if (
      file &&
      file.name &&
      (file.name.split('.').pop() === 'csv' ||
        file.name.split('.').pop() === 'xls' ||
        file.name.split('.').pop() === 'xlsx')
    ) {
      const content = await file.text();
      const csvContent = Papa.parse(content);
      if (csvContent.errors.length) {
        showToast({
          type: ENUMS.TOAST_TYPES.WARNING,
          message:
            'There was an error with the format of your file. Click "See Format" to get an example',
        });
      } else {
        setImportedOrdersCSV(file);
        this.setState({ uploadedSuccess: true, fileName: file.name });
      }
    } else {
      showToast({
        type: ENUMS.TOAST_TYPES.WARNING,
        message: 'Please drop only CSV file !!!',
      });
    }
  };

  setSingleEntry = (e, keyName) => {
    const {
      onboardingStore: { setImportedData, importedData },
    } = this.props;
    const singleEntry = {
      ...importedData[0],
      [keyName]: e.target.value,
    };
    const singleEntryFilled = !!(singleEntry.source_id || singleEntry.destination_id);
    setImportedData(singleEntryFilled ? [singleEntry] : []);
    this.setState({ singleEntryFilled });
  };

  cancelFile = () => {
    const {
      onboardingStore: { setImportedData },
    } = this.props;
    setImportedData([]);
    this.setState({ uploadedSuccess: false, fileName: '' });
  };

  cancelFileOrders = () => {
    const {
      ordersStore: { setImportedOrdersCSV },
    } = this.props;
    setImportedOrdersCSV({});
    this.setState({ uploadedSuccess: false, fileName: '' });
  };

  render() {
    const {
      intl,
      noDescriptionText = false,
      width = '200px',
      forOnboarding = false,
      justContents = false,
      forOrdersImport = false,
      onboardingStore: {
        importedData,
        enableNextWizard,
        disableNextWizard,
        setImportSource,
        importSource,
        sellerAccounts,
        defaultSellersAccount,
        setDestinationAccountId,
        noImportedData,
      },
      discoveryStore: { availableSourceMarketPlaces,availableDestinationMarketPlaces,setListingSelected,listingMarket },
      ordersStore: { setStoreAccountId, isfileImported },
    } = this.props;

    const { fileName, uploadedSuccess, singleEntryFilled, isContent } = this.state;
    if (uploadedSuccess) {
      enableNextWizard();
    } else {
      disableNextWizard();
    }

    const importOrdersModalContent = (
      <>
        <span
          css={css`
            text-align: center;
          `}
        >
          Please upload the file downloaded from the Seller&apos;s hub report on your eBay account.
        </span>

        <FlexContainer>
          <DownloadSample
            extraCss="margin-top: 5px;"
            href="/assets/sampleFiles/importOrdersSample.csv"
            target="_blank"
            linkText={intl.formatMessage({ id: 'onboarding.advanced.screen7.seeFormat' })}
          />
        </FlexContainer>
        <FlexContainer
          css={css`
            margin-top: 20px;
          `}
        >
          <span
            css={css`
              margin-right: 10px;
            `}
          >
            Select store{' '}
          </span>
          <Select
            onChange={e => setStoreAccountId(e)}
            style={{
              color: '#0070ba',
              width: '150px',
            }}
          >
            {sellerAccounts.map(item => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </FlexContainer>
        <FlexContainer
          css={css`
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          `}
        >
          <Dropzone
            accept={['application/vnd.ms-excel', '.csv', '']}
            onDrop={this.onDropOrders}
            ref={node => {
              this.dropzoneRef = node;
            }}
            disableClick
            style={{
              height: '90px',
              border: `2px dashed ${themeColors.dirtyBlue}`,
              borderRadius: '4px',
              width: '70%',
              margin: '10% 0',
            }}
            acceptStyle={{ border: `2px dashed ${themeColors.green}` }}
            rejectStyle={{ border: `2px dashed ${themeColors.pink}` }}
            activeStyle={{ border: `2px dashed ${themeColors.dirtyBlue}` }}
            disabled={singleEntryFilled}
          >
            {!isContent && (
              <IconsWraper>
                <IconSvg type="copy" size={25} />
                <IconSvg type="csv" size={25} />
              </IconsWraper>
            )}
            <UploadLink
              onClick={() => {
                this.dropzoneRef.open();
              }}
              disabled={singleEntryFilled}
            >
              {intl.formatMessage({ id: 'onboarding.advanced.screen7.uploadCSV' })}
            </UploadLink>
          </Dropzone>
        </FlexContainer>
      </>
    );

    const customDropzone = (
      <React.Fragment>
        {!noDescriptionText && (
          <ImportCsvText>
            <FormattedMessage id="onboarding.advanced.screen7.importFromCSV" />
          </ImportCsvText>
        )}
        <FlexContainer>
          <Select
            // defaultValue={importSource}
            value={importSource}
            css={css`
              margin-right: 20px;
              color: #0070ba;
            `}
            onChange={market => {
              setImportSource(market);
            }}
          >
            {availableSourceMarketPlaces.map(market => (
              <Option value={market} key={`discoverMarket-${market}`}>
                {intl.formatMessage({ id: `discovery.marketByEnum_${market}` })}
              </Option>
            ))}
          </Select>
          <Select
            // defaultValue={listingMarket}
            value={listingMarket}
            css={css`
              margin-right: 20px;
              color: #0070ba;
            `}
            onChange={market => {
              setListingSelected(market);
            }}
          >
            {availableDestinationMarketPlaces.map(market => (
              <Option value={market} key={`discoverMarket-${market}`}>
                {intl.formatMessage({ id: `discovery.marketDestinationByEnum_${market}` })}
              </Option>
            ))}
          </Select>
        </FlexContainer>
        <FlexContainer style={{marginTop:'10px'}}>
          <Select
            defaultValue={defaultSellersAccount.id}
            onChange={setDestinationAccountId}
            style={{
              color: '#0070ba',
            }}
          >
            {sellerAccounts.map(item => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </FlexContainer>
        {!forOnboarding ? (
          <CategoryTitle>{intl.formatMessage({ id: 'listing.importSingle' })}</CategoryTitle>
        ) : null}
        {!forOnboarding ? (
          <FlexContainer>
            <Input
              placeholder="Source ID"
              disabled={uploadedSuccess}
              value={!uploadedSuccess && importedData.length === 1 ? importedData[0].source_id : ''}
              onChange={e => this.setSingleEntry(e, 'source_id')}
              style={{ margin: '0 2.5px 0 5px' }}
            />
            <Input
              placeholder="Destination ID"
              disabled={uploadedSuccess}
              value={
                !uploadedSuccess && importedData.length === 1 ? importedData[0].destination_id : ''
              }
              onChange={e => this.setSingleEntry(e, 'destination_id')}
              style={{ margin: '0 5px 0 2.5px' }}
            />
          </FlexContainer>
        ) : null}

        {!forOnboarding ? <FlexContainer>-or-</FlexContainer> : null}
        {!forOnboarding ? (
          <CategoryTitle>{intl.formatMessage({ id: 'listing.importFromCSV' })}</CategoryTitle>
        ) : null}
        <DownloadSample
          extraCss="margin-top: 5px;"
          href="/assets/sampleFiles/example.csv"
          target="_blank"
          linkText={intl.formatMessage({ id: 'onboarding.advanced.screen7.seeFormat' })}
        />
        <Dropzone
          accept={['application/vnd.ms-excel', '.csv', '']}
          onDrop={this.onDrop}
          ref={node => {
            this.dropzoneRef = node;
          }}
          disableClick
          style={{
            height: '90px',
            border: `2px dashed ${themeColors.dirtyBlue}`,
            borderRadius: '4px',
            width: '70%',
            margin: '10% 0',
          }}
          acceptStyle={{ border: `2px dashed ${themeColors.green}` }}
          rejectStyle={{ border: `2px dashed ${themeColors.pink}` }}
          activeStyle={{ border: `2px dashed ${themeColors.dirtyBlue}` }}
          disabled={singleEntryFilled}
        >
          {!isContent && (
            <IconsWraper>
              <IconSvg type="copy" size={25} />
              <IconSvg type="csv" size={25} />
            </IconsWraper>
          )}
          <UploadLink
            onClick={() => {
              this.dropzoneRef.open();
            }}
            disabled={singleEntryFilled}
          >
            {intl.formatMessage({ id: 'onboarding.advanced.screen7.uploadCSV' })}
          </UploadLink>
        </Dropzone>
      </React.Fragment>
    );
    if (justContents) {
      return (
        <React.Fragment>
          {customDropzone}
          {!noImportedData && (
            <FileName name={fileName} type="csv" size={20} cancelHandler={this.cancelFile} />
          )}
        </React.Fragment>
      );
    }
    if (forOrdersImport) {
      return (
        <React.Fragment>
          {importOrdersModalContent}
          {!isfileImported && (
            <FileName name={fileName} type="csv" size={20} cancelHandler={this.cancelFileOrders} />
          )}
        </React.Fragment>
      );
    }

    return (
      <FlexContainer flexDirection="column">
        <ImportCsvContainer show={uploadedSuccess} width={width}>
          {customDropzone}
        </ImportCsvContainer>
        <UploadSuccess show={!uploadedSuccess}>
          {!noImportedData && (
            <FileName name={fileName} type="csv" size={20} cancelHandler={this.cancelFile} />
          )}
          <FormattedMessage id="common.success" />
        </UploadSuccess>
      </FlexContainer>
    );
  }
}

ReadyToLaunchAdvanced.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  onboardingStore: PropTypes.object,
  ordersStore: PropTypes.object,
  toastsStore: PropTypes.object,
  intl: PropTypes.object,
  noDescriptionText: PropTypes.bool,
  forOnboarding: PropTypes.bool,
  justContents: PropTypes.bool,
  width: PropTypes.string,
};

export default ReadyToLaunchAdvanced;
